/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
/**
 * 
 * @export
 * @interface DataPointRequestDto
 */
export interface DataPointRequestDto {
    /**
     * 
     * @type {string}
     * @memberof DataPointRequestDto
     */
    startDate?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DataPointRequestDto
     */
    endDate?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof DataPointRequestDto
     */
    dataSetIds?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof DataPointRequestDto
     */
    $type?: DataPointRequestDtoTypeEnum;
}


/**
 * @export
 */
export const DataPointRequestDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedResultsDtoDataPointRequestDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.Results.Dto.DataPointRequestDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type DataPointRequestDtoTypeEnum = typeof DataPointRequestDtoTypeEnum[keyof typeof DataPointRequestDtoTypeEnum];



/**
 * Check if a given object implements the DataPointRequestDto interface.
 */
export function instanceOfDataPointRequestDto(value?: unknown): value is DataPointRequestDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(DataPointRequestDtoTypeEnum)[0];
}

export function DataPointRequestDtoFromJSON(json: any): DataPointRequestDto {
    return DataPointRequestDtoFromJSONTyped(json, false);
}

export function DataPointRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): DataPointRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'startDate': json['startDate'] == null ? undefined : json['startDate'],
        'endDate': json['endDate'] == null ? undefined : json['endDate'],
        'dataSetIds': json['dataSetIds'] == null ? undefined : json['dataSetIds'],
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function DataPointRequestDtoToJSON(value?: DataPointRequestDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'startDate': value['startDate'],
        'endDate': value['endDate'],
        'dataSetIds': value['dataSetIds'],
        '$type': value['$type'],
    });
}

